import React from "react";

import { cn } from "@/utils/cn";

interface FormProps
  extends Pick<
    React.FormHTMLAttributes<HTMLFormElement>,
    "className" | "autoComplete"
  > {
  // React 19 types the native onSubmit as SubmitEvent; the form passes a
  // FormEvent, so declare it explicitly rather than picking it off the DOM type.
  onSubmit?: React.FormEventHandler<HTMLFormElement>;
  children: React.ReactNode;
  /** Password-manager / autofill opt-out hints (e.g. data-lpignore, data-1p-ignore). */
  [dataAttr: `data-${string}`]: string | undefined;
}

/** Form element with custom styles. */
const Form: React.FC<FormProps> = ({
  onSubmit,
  children,
  className,
  ...filteredProps
}) => {
  const handleSubmit: React.FormEventHandler<HTMLFormElement> =
    React.useCallback(
      (event) => {
        event.preventDefault();

        if (onSubmit) {
          onSubmit(event);
        }
      },
      [onSubmit],
    );

  return (
    <form
      data-testid="form"
      onSubmit={handleSubmit}
      className={cn("space-y-4", className)}
      {...filteredProps}
    >
      {children}
    </form>
  );
};

export default Form;
